import { useQuery } from "react-query";
import { getVendorWithVendorStorage } from "../../../../actions/CarrierAgreementMgmt/Vendor";

export const useGetVendorWithVendorStorage = () => {
  return useQuery("GetVendorWithVendorStorage", getVendorWithVendorStorage, {
    refetchOnWindowFocus: false,
  });
};
